import React from 'react'

interface SummaryItemProps {
  label: string
  value: string | React.ReactNode
  className?: string
}

export const SummaryItem: React.FC<SummaryItemProps> = ({
  label,
  value,
  className = '',
}) => {
  return (
    <div className={className}>
      <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-0.5">
        {label}
      </p>
      <p className="text-sm font-medium text-foreground">{value}</p>
    </div>
  )
}
